/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.fc-agendaWeek-button[_ngcontent-%COMP%], .fc-agendaDay-button[_ngcontent-%COMP%], .fc-listYear-button[_ngcontent-%COMP%] {\n    display: none;\n}\n@media screen and ( min-width: 768px ){\n    .fc-agendaWeek-button[_ngcontent-%COMP%], .fc-agendaDay-button[_ngcontent-%COMP%], .fc-listYear-button[_ngcontent-%COMP%] {\n        display: block;\n    }\n}\n.padTop[_ngcontent-%COMP%]{\n    margin-top: 2.8%;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9zaGFyZWQvdWkvaW50ZXJwcmV0ZXIvaW50ZXJwcmV0ZXIuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92ZXJjZWwvd29ya3BhdGgwL3NyYy9hcHAvc2hhcmVkL3VpL2ludGVycHJldGVyL2ludGVycHJldGVyLmNvbXBvbmVudC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/ui/interpreter/interpreter.component.css.shim.ngstyle.ts